import React from 'react';
import PropTypes from 'prop-types';
import '../../scss/style.scss';

const ConfirmModal = ({ setPopupOpen, popupOpen }) => {
  const handleOk = () => {
    setPopupOpen(false);
  };

  const handleCancel = () => {
    window.location.href = 'https://www.lilly.com/uk/';
  };

  return (
    <>
      {popupOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <img src="public/img/LillyLogo_1.png" alt="lilly-logo" style={{ width: '80px', marginBottom: '25px' }} />
            <p>Are you a UK Healthcare provider?</p>
            <p>The information contained on this site is intended for UK Healthcare Professionals and Other Relevant Decision Makers only.</p>
            <div className="modal-buttons">
              <button className="yes-button" type="button" onClick={handleOk}>
                Yes
              </button>
              <button className="no-button" type="button" onClick={handleCancel}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

ConfirmModal.propTypes = {
  setPopupOpen: PropTypes.func.isRequired,
  popupOpen: PropTypes.bool.isRequired,
};

export default ConfirmModal;
